<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="检查日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择检查日期" v-decorator="['createTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="更新日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择更新日期" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorId']" placeholder="请输入医生id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorName']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="号源id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorRegisterId']" placeholder="请输入号源id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="录入出诊日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lrVisitTime']" placeholder="请输入录入出诊日期"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="计划出诊日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['jhVisitTime']" placeholder="请输入计划出诊日期"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="日期异常" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ycVisitTime']" placeholder="请输入日期异常"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="录入时间段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lrVisitPart']" placeholder="请输入录入时间段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="计划时间段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['jhVisitPart']" placeholder="请输入计划时间段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="时间段异常" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ycVisitPart']" placeholder="请输入时间段异常"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="录入总金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lrAmount']" placeholder="请输入录入总金额"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="实际总金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sjAmount']" placeholder="请输入实际总金额"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="金额异常" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ycAmout']" placeholder="请输入金额异常"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'ZztShenchaForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/zztShencha/zztShencha/add",
          edit: "/zztShencha/zztShencha/edit",
          queryById: "/zztShencha/zztShencha/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'createTime','updateTime','doctorId','doctorName','doctorRegisterId','lrVisitTime','jhVisitTime','ycVisitTime','lrVisitPart','jhVisitPart','ycVisitPart','lrAmount','sjAmount','ycAmout'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'createTime','updateTime','doctorId','doctorName','doctorRegisterId','lrVisitTime','jhVisitTime','ycVisitTime','lrVisitPart','jhVisitPart','ycVisitPart','lrAmount','sjAmount','ycAmout'))
      },
    }
  }
</script>